module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.e21a2217.jpg";